type Point = { day: string; requests: number; errors: number };

export function Sparkline({
  data,
  width = 320,
  height = 64,
}: {
  data: Point[];
  width?: number;
  height?: number;
}) {
  if (data.length === 0) {
    return <div className="text-xs text-slate-500">No traffic in this window.</div>;
  }

  const pad = 4;
  const innerW = width - pad * 2;
  const innerH = height - pad * 2;
  const max = Math.max(1, ...data.map((d) => d.requests));
  const stepX = innerW / Math.max(1, data.length - 1);

  const points = data.map((d, i) => {
    const x = pad + i * stepX;
    const y = pad + innerH - (d.requests / max) * innerH;
    return { x, y, ...d };
  });

  const lineD = points.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");
  const areaD = `${lineD} L${pad + innerW},${pad + innerH} L${pad},${pad + innerH} Z`;

  return (
    <div>
      <svg
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        height={height}
        className="block"
        role="img"
        aria-label={`${data.length}-day request sparkline`}
      >
        <defs>
          <linearGradient id="sparkFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgb(16 185 129)" stopOpacity="0.35" />
            <stop offset="100%" stopColor="rgb(16 185 129)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={areaD} fill="url(#sparkFill)" />
        <path d={lineD} fill="none" stroke="rgb(16 185 129)" strokeWidth={1.6} />
        {points.map((p) => (
          <g key={p.day}>
            <circle cx={p.x} cy={p.y} r={1.8} fill="rgb(16 185 129)" />
            {p.errors > 0 && (
              <circle
                cx={p.x}
                cy={p.y}
                r={4}
                fill="none"
                stroke="rgb(244 63 94)"
                strokeWidth={1.1}
                opacity={0.7}
              />
            )}
            <title>
              {p.day}: {p.requests} request{p.requests === 1 ? "" : "s"}
              {p.errors > 0 ? `, ${p.errors} error${p.errors === 1 ? "" : "s"}` : ""}
            </title>
          </g>
        ))}
      </svg>
      <div className="flex justify-between text-[10px] text-slate-500 mono mt-1">
        <span>{data[0].day.slice(5)}</span>
        <span>{data[data.length - 1].day.slice(5)}</span>
      </div>
    </div>
  );
}
